import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import _, { groupBy, orderBy } from "lodash";
import { Card, Row, Col } from "react-bootstrap";

import {
  fetchGenericData,
  updateRecord,
} from "../../../../webservices/generic/genericDataWs";
import { addToastAction } from "../../../../actions/generic/toastActions";
import FuseCollapsiblePanel from "../../FuseCollapsiblePanel";
import FuseToolbar from "../../FuseToolbar";
import FuseInputBox from "../../inputFields/FuseInputBox";
import { ToastTypes } from "../../modals/FuseToast";
import moment from "moment";
import FuseForm from "../../FuseForm";
import LoadingSpinner from "../../LoadingSpinner";

export function DetailPanel(props) {
  props.childRef(useRef());
  const [state, setState] = useState({
    isInEdit: false,
    query: {},
    data: {},
    originalData: {},
    isLoading: false,
    panelInfo: props.panelInfo,
  });

  const prevProps = useRef(props).current;

  // componentDidMount
  useEffect(() => {}, []);

  // componentDidUpdate
  useEffect(() => {
    loadGenericDataFromQuery();
  }, [props.query]);

  const loadGenericDataFromQuery = () => {
    if (_.isEmpty(props.query) || _.isEmpty(props.query.query)) {
      return;
    }

    var query = {
      ...props.query.query,
      ...{
        panelNumber: props.panelInfo.panelNumber,
        panelId: props.panelInfo.panelNumber,
      },
    };
    setState({ ...state, isLoading: true });
    fetchGenericData(query)
      .then((response) => {
        //Todo: May need to refine the identification of errors vs success here for different error scenarios so we handle it generically
        if (!_.isEmpty(response.error)) {
          console.log("Error fetching generic data:");
          console.log(JSON.stringify(response.error));
          props.showDataFetchError(response.error.message);
        } else if (response.data.success === true) {
          let data = response.data.result.data;
          setState({
            ...state,
            data: data[0],
            isInEdit: false,
            isLoading: false,
          });
          props.onPanelVisible(props.panelInfo.panelNumber);
        } else {
          console.log("Error fetching generic data:");
          console.log(JSON.stringify(response.data));
          props.showDataFetchError();
          setState({ ...state, isInEdit: false, isLoading: false });
        }
      })
      .catch(function (error) {
        console.log("exception:" + error);
        props.showDataFetchError(error.message);
        setState({ ...state, isInEdit: false, isLoading: false });
      });
  };

  const updateRecordDetails = () => {
    var data = state.data;

    var keys = Object.keys(data);
    keys.forEach((key, index) => {
      if (_.isObject(data[key])) {
        data[key] = data[key].value;
      }
    });

    props.onIsLoading(true);
    updateRecord(data, props.screenId, props.panelInfo.panelNumber)
      .then((response) => {
        if (!_.isEmpty(response.error)) {
          console.log("Error editing record:");
          console.log(JSON.stringify(response.error));
          props.addToast(ToastTypes.ERROR, "Error updating record details");
          props.onIsLoading(false);
        } else if (response.data.success === true) {
          let item = response.data.result;
          setState({ ...state, data: item, isInEdit: false });
          props.addToast(ToastTypes.SUCCESS, "Record details updated");
          props.onIsLoading(false);
        } else {
          console.log("Error editing record:");
          console.log(JSON.stringify(response.data));
          props.addToast(ToastTypes.ERROR, "Error updating record details");
          props.onIsLoading(false);
        }
      })
      .catch(function (error) {
        console.log("exception:" + error);
        props.addToast(ToastTypes.ERROR, "Error updating record details");
        props.onIsLoading(false);
      });
  };

  const onUpdateData = (column, value) => {
    var cloneState = _.cloneDeep(state);
    var currentData = cloneState.data;

    if (
      column.columnType === "DateTime" ||
      column.tableColumn.columnType === "DateTime"
    ) {
      if (value === "" || value === null) {
        currentData[`${column.tableColumn.name}`] = null;
      } else {
        currentData[`${column.tableColumn.name}`] = moment(value).format(
          "YYYY-MM-DD HH:mm:ss"
        );
      }
    } else if (column.columnType === "dropdown") {
      currentData[`${column.tableColumn.name}`] = value;
      // currentData[`${column.tableColumn.name}`] = value[0];
    } else {
      if (value === "") {
        currentData[`${column.tableColumn.name}`] = null;
      } else {
        currentData[`${column.tableColumn.name}`] = value;
      }
    }

    setState(cloneState);
  };

  const onEditClicked = () => {
    var clonedData = _.cloneDeep(state.data);

    setState({ ...state, isInEdit: !state.isInEdit, originalData: clonedData });
  };

  const onSaveClicked = () => {
    // this.updateRecord();
  };

  const onUndoClicked = () => {
    if (!_.isEqual(state.data, state.originalData)) {
      setState({ ...state, data: state.originalData });
    }
    setState({ ...state, isInEdit: false });
  };

  const onRefreshClicked = () => {
    setState({ ...state, isLoading: true });
    loadGenericDataFromQuery();
  };
  const hasAttachments = () => state.panelInfo.allowAttachments === true;

  const detailPanelToolbar = () => {
    console.log(state);
    return (
      <Card>
        <Card.Body>
          {/* <h3>Actions</h3> */}
          <FuseToolbar
            showSave={state.isInEdit}
            showEdit={!state.isInEdit}
            showUndo={state.isInEdit}
            showAttachment={hasAttachments()}
            attachment={state.data.attachment} //Passed from parent
            requiredAttachments={state.data.tableAttachmentsReact}
            onUpdateSourceKey={(sourceKey)=>{
              // state.data.attachment = sourceKey;
              //not necessary since detail panel is not allowed to create new source key
              // state.sourceKey = sourceKey;
            }}
            showRefresh={!_.isEmpty(props.query)}
            onEditClicked={onEditClicked}
            // onSaveClicked={this.onSaveClicked}
            onUndoClicked={onUndoClicked}
            onRefreshClicked={onRefreshClicked}
          />
        </Card.Body>
      </Card>
    );
  };

  const renderLoading = () => {
    return <LoadingSpinner className="d-flex justify-content-center " />;
  };

  if (_.isEmpty(props.screenInfo) || _.isEmpty(props.screenInfo.panels)) {
    return null;
  } else {
    const panel = state.panelInfo;
    var detailWells = Object.values(
      _.groupBy(panel.columns, "detailWell")
    ).filter((detailWell) => detailWell.detailWell !== "");
    return (
      <div>
        {state.isLoading && _.isEmpty(state.data) ? (
          renderLoading()
        ) : (
          <div>
            {!_.isEmpty(state.data) && (
              <FuseCollapsiblePanel
                isLoading={props.fetchingData || state.isLoading}
                title={panel.header}
              >
                {!state.isInEdit ? (
                  <div>
                    {detailPanelToolbar()}
                    {detailWells.map((detailWell, detailWell_index) => {
                      return (
                        <Card
                          key={detailWell[0].tableColumn.name}
                          className="card-box"
                        >
                          <Card.Body>
                            <Row key={detailWell_index}>
                              <Col xs={4} lg={4}>
                                <h4>
                                  <u>
                                    {detailWell[0].detailWell
                                      .charAt(0)
                                      .toUpperCase() +
                                      detailWell[0].detailWell.slice(1)}
                                  </u>
                                </h4>
                              </Col>
                            </Row>
                            <Row>
                              {detailWell
                                .filter((column) => column.visible)
                                .map((column, column_index) => {
                                  let key = `${column.tableColumn.description}_${detailWell_index}`;
                                  var answer =
                                    state.data[`${column.tableColumn.name}`];

                                  if (
                                    answer !== null &&
                                    answer !== undefined &&
                                    answer !== ""
                                  ) {
                                    if (
                                      column.columnType === "DateTime" ||
                                      column.tableColumn.columnType ===
                                        "DateTime"
                                    ) {
                                      answer =
                                        moment(answer).format("YYYY-MM-DD");
                                    } else if (
                                      column.columnType === "Boolean"
                                    ) {
                                      answer = answer === true ? "Yes" : "No";
                                    } else if (
                                      column.columnType === "dropdown" ||
                                      column.columnType === "list_of_values"
                                    ) {
                                      if (column.dropDownValues.length > 0) {
                                        answer = column.dropDownValues.find(
                                          (dropdownValue) =>
                                            dropdownValue.key === answer
                                        );

                                        if (answer !== undefined) {
                                          answer = answer.value;
                                        }
                                      }
                                    } else {
                                      answer = answer.toString();
                                    }
                                  }

                                  return (
                                    <Col
                                      key={key}
                                      xs={12}
                                      sm={12}
                                      md={6}
                                      lg={4}
                                    >
                                      <div style={{ padding: "10px" }}>
                                        <p>
                                          <b>
                                            {column.tableColumn.description}
                                          </b>
                                        </p>
                                        {_.isEmpty(answer) ||
                                        answer === null ||
                                        answer === undefined ? (
                                          <p style={{ color: "#a9a9a9" }}>
                                            Not specified
                                          </p>
                                        ) : (
                                          <p>{answer.toString()}</p>
                                        )}
                                      </div>
                                    </Col>
                                  );
                                })}
                            </Row>
                          </Card.Body>
                        </Card>
                      );
                    })}
                  </div>
                ) : (
                  <div>
                    <FuseForm
                      onSubmit={(e) => {
                        updateRecordDetails();
                      }}
                    >
                      {detailPanelToolbar()}
                      {detailWells.map((detailWell, detailWell_index) => {
                        return (
                          <Card
                            key={detailWell[0].detailWell}
                            className="card-box"
                          >
                            <Card.Body>
                              <Row key={detailWell_index}>
                                <Col xs={4} lg={4}>
                                  <h4>
                                    <u>
                                      {detailWell[0].detailWell
                                        .charAt(0)
                                        .toUpperCase() +
                                        detailWell[0].detailWell.slice(1)}
                                    </u>
                                  </h4>
                                </Col>
                              </Row>
                              <Row>
                                {detailWell
                                  .filter((column) => column.visible)
                                  .map((column, column_index) => {
                                    let key = `${column.tableColumn.description}_${detailWell_index}`;
                                    let id = `${column.tableColumn.id}`;
                                    var answer =
                                      state.data[`${column.tableColumn.name}`];
                                    if (
                                      answer !== null ||
                                      answer !== undefined
                                    ) {
                                      if (
                                        column.columnType === "dropdown" ||
                                        column.columnType === "list_of_values"
                                      ) {
                                        if (_.isNumber(answer)) {
                                          answer = column.dropDownValues.find(
                                            (dropdownValue) =>
                                              dropdownValue.key === answer
                                          );
                                        } else {
                                          answer = {
                                            key: "default",
                                            value: answer,
                                            label: answer,
                                          };
                                        }

                                        if (answer !== undefined) {
                                          answer = answer.value;
                                        }
                                      }
                                    }

                                    var regExpValidationMessage = "";

                                    if (
                                      column.columnType === "Int32" ||
                                      column.columnType === "Int64"
                                    ) {
                                      regExpValidationMessage =
                                        "May only contain numerical values";
                                    } else if (column.columnType === "double") {
                                      regExpValidationMessage =
                                        "May only contain decimal values";
                                    } else if (column.columnType === "email") {
                                      regExpValidationMessage =
                                        "Please provide a valid email address";
                                    } else if (
                                      column.columnType === "id_number"
                                    ) {
                                      regExpValidationMessage =
                                        "May only contain numerical values";
                                    } else if (column.columnType === "String") {
                                      regExpValidationMessage =
                                        "May only contain alphabetical characters";
                                    } else {
                                      regExpValidationMessage = "Invalid input";
                                    }

                                    return (
                                      <Col
                                        key={`${key}`}
                                        xs={12}
                                        sm={12}
                                        md={6}
                                        lg={4}
                                      >
                                        <div style={{ padding: "10px" }}>
                                          <p>
                                            <b>
                                              {column.tableColumn.description}
                                            </b>
                                          </p>
                                          {(column.columnType === "String" ||
                                            column.columnType === "Int32" ||
                                            column.columnType === "Int64" ||
                                            column.columnType === "Double" ||
                                            column.columnType ===
                                              "address_text" ||
                                            column.columnType === "email" ||
                                            column.columnType ===
                                              "id_number") && (
                                            <FuseInputBox
                                              id={id}
                                              name={`${column.tableColumn.name}`}
                                              type={"text"}
                                              maxLength={
                                                column.tableColumn.length
                                              }
                                              required={
                                                !column.tableColumn.nullable
                                              }
                                              editable={true}
                                              disabled={!column.updateable}
                                              regExpMissmatchMessage={
                                                regExpValidationMessage
                                              }
                                              regExp={column.regex}
                                              showErrors={!column.tableColumn.nullable && column.updateable}
                                              isValid={() => {
                                                return true;
                                              }}
                                              value={answer}
                                              onChange={(val) => {
                                                onUpdateData(column, val);
                                              }}
                                            />
                                          )}
                                          {(column.columnType === "DateTime" ||
                                            column.tableColumn.columnType ===
                                              "DateTime") && (
                                            <FuseInputBox
                                              id={id}
                                              name={`${column.tableColumn.name}`}
                                              type={
                                                column.tableColumn.columnType
                                              }
                                              required={
                                                !column.tableColumn.nullable
                                              }
                                              editable={true}
                                              disabled={!column.updateable}
                                              showErrors={!column.tableColumn.nullable && column.updateable}
                                              regExp={column.regex}
                                              isValid={() => {
                                                return true;
                                              }}
                                              value={
                                                answer === undefined ||
                                                answer === null
                                                  ? null
                                                  : Date.parse(answer)
                                              } //{ row[column.tableColumn.name] }
                                              onChange={(val) => {
                                                onUpdateData(column, val);
                                              }}
                                            />
                                          )}
                                          {column.columnType === "Boolean" && (
                                            <FuseInputBox
                                              id={id}
                                              type={column.columnType}
                                              isClearable
                                              isSearchable
                                              isMulti={false}
                                              maxLength={
                                                column.tableColumn.length
                                              }
                                              required={
                                                !column.tableColumn.nullable
                                              }
                                              editable={true}
                                              disabled={!column.updateable}
                                              showErrors={!column.tableColumn.nullable && column.updateable}
                                              regExp={column.regex}
                                              menuPortalTarget={document.body}
                                              className="col-sm-12"
                                              value={answer}
                                              dropKeyColumn="key"
                                              dropValueColumn="value"
                                              dropDownValues={[
                                                { key: "All", label: "All" },
                                                {
                                                  key: "Empty",
                                                  label: "Empty",
                                                },
                                                { key: "True", label: "True" },
                                                {
                                                  key: "False",
                                                  label: "False",
                                                },
                                              ]}
                                              dropDownDisplayValues={[
                                                { key: "All", value: "All" },
                                                {
                                                  key: "Empty",
                                                  value: "Empty",
                                                },
                                                { key: "True", value: "True" },
                                                {
                                                  key: "False",
                                                  value: "False",
                                                },
                                              ]}
                                              isValid={() => {
                                                return true;
                                              }}
                                              onChange={(val) => {
                                                onUpdateData(column, val);
                                              }}
                                            />
                                          )}
                                          {column.columnType === "dropdown" && (
                                            <FuseInputBox
                                              type={column.columnType}
                                              isClearable
                                              isSearchable
                                              isMulti={false}
                                              required={
                                                !column.tableColumn.nullable
                                              }
                                              editable={true}
                                              disabled={!column.updateable}
                                              showErrors={!column.tableColumn.nullable && column.updateable}
                                              regExp={column.regex}
                                              regExpMissmatchMessage={regExpValidationMessage}
                                              menuPortalTarget={document.body}
                                              className="col-sm-12"
                                              value={
                                                answer === "" ? "" : answer
                                              }
                                              dropKeyColumn="key"
                                              dropValueColumn="value"
                                              dropDownValues={
                                                column.dropDownValues
                                              }
                                              dropDownDisplayValues={
                                                column.dropDownDisplayValues
                                              }
                                              isValid={() => {
                                                return true;
                                              }}
                                              onChange={(val) => {
                                                onUpdateData(column, val);
                                              }}
                                            />
                                          )}
                                          {column.columnType ===
                                            "list_of_values" && (
                                            <FuseInputBox
                                              id={id}
                                              name="sampleDate"
                                              type="list_of_values"
                                              value={answer} //{ row[column.tableColumn.name] }
                                              regExp={column.regex}
                                              lovTable={
                                                column.additionalSourceTable
                                              }
                                              lovKeyColumn={
                                                column.additionalSourceKey
                                              }
                                              lovValueColumn={
                                                column.additionalSourceValue
                                              }
                                              lovFilterKey={
                                                column.additionalSourceFilter
                                              }
                                              lovFilterValue={
                                                state.data[
                                                  `${column.additionalSourceLookup}`
                                                ]
                                              }
                                              editable={true}
                                              disabled={!column.updateable}
                                              showErrors={!column.tableColumn.nullable && column.updateable}
                                              required={
                                                !column.tableColumn.nullable
                                              }
                                              onChange={(val) => {
                                                onUpdateData(column, val);
                                              }}
                                            />
                                          )}
                                        </div>
                                      </Col>
                                    );
                                  })}
                              </Row>
                            </Card.Body>
                          </Card>
                        );
                      })}
                    </FuseForm>
                  </div>
                )}
              </FuseCollapsiblePanel>
            )}
          </div>
        )}
      </div>
    );
  }
}

DetailPanel.propTypes = {
  //fetchScreenInfo: PropTypes.func.isRequired
  // panelId: PropTypes.number.isRequired,
  // screenId: PropTypes.number.isRequired
};

DetailPanel.defaultProps = {
  onIsLoading: (isLoading) => {}
}

const mapStateToProps = (state, ownProps) => {
  const { genericPageState } = state;
  let panelInfo =
    !_.isEmpty(state.screenInfo) && !_.isEmpty(state.screenInfo.panels)
      ? state.screenInfo.panels.filter((x) => x.id === ownProps.panelId)[0]
      : {};
  let query = !_.isEmpty(genericPageState)
    ? genericPageState.queries.filter(
        (x) =>
          x.screenId === ownProps.screenId &&
          x.targetPanelNr === panelInfo.panelNumber
      )[0]
    : {};
  return {
    fetchingData: state.fetchingData === true,
    auth: state.auth,
    query: query,
    screenInfo: state.screenInfo,
    panelInfo: panelInfo,
  };
};

export default connect(
  // map state to props
  mapStateToProps,
  // map dispatch to props
  (dispatch, ownProps) => ({
    addToast: (type, text) => dispatch(addToastAction(type, text)),
  })
)(DetailPanel);
